import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

// Import page components
import Home from './pages/Home';
import ExpertsPage from './pages/Experts';
import CoursesPage from './pages/Courses';
import CourseCard from './pages/ContactUs';
import DiscountPage from './pages/Discounts';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/Subscriptions'; // New subscription page

// Auth components
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Register from './components/auth/Register';
import Login from './components/auth/Login';

// Auth provider and protected route
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext'; // New subscription provider
import { GoogleOAuthProvider } from '@react-oauth/google';
import ProtectedRoute from './components/auth/ProtectedRoute';

const App = () => {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";
  
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Router>
        <AuthProvider>
          <SubscriptionProvider> {/* Wrap the app with SubscriptionProvider */}
            <div className="flex flex-col min-h-screen">
              <Helmet>
                <meta charSet="utf-8" />
                <title>MedEra - Expert-Led App</title>
                <meta name="description" content="EduPlatform offers expert-led courses in various fields. Enhance your skills with our interactive learning platform." />
                <meta name="keywords" content="education, courses, online learning, experts, skills" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                {/* Open Graph / Social Media */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="EduPlatform - Expert-Led Courses" />
                <meta property="og:description" content="Enhance your skills with our expert-led interactive learning platform." />
                <meta property="og:image" content="/assets/og-image.jpg" />
                <meta property="og:url" content="https://eduplatform.example.com" />
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EduPlatform - Expert-Led Courses" />
                <meta name="twitter:description" content="Enhance your skills with our expert-led interactive learning platform." />
                <meta name="twitter:image" content="/assets/twitter-image.jpg" />
                {/* Favicon */}
                <link rel="icon" href="/favicon.ico" />
                {/* Fonts */}
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@500;600;700&display=swap" rel="stylesheet" />
                {/* Razorpay script for payments */}
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
              </Helmet>
              
              <Navbar />
              
              <main className="flex-grow pt-16">
                <Routes>
                  {/* Public routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/experts" element={<ExpertsPage />} />
                  <Route path="/courses" element={<CoursesPage />} />
                  <Route path="/discount" element={<DiscountPage />} />
                  <Route path="/contact" element={<CourseCard />} />
                  
                  {/* Auth routes */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  
                  {/* Subscription routes - Protected */}
                  <Route 
                    path="/subscription" 
                    element={
                      // <ProtectedRoute>
                        <SubscriptionPage />
                      // </ProtectedRoute>
                    } 
                  />
                  
                  {/* Additional subscription routes */}
                  <Route 
                    path="/subscription/plans" 
                    element={
                      <ProtectedRoute>
                        <SubscriptionPage initialTab="plans" />
                      </ProtectedRoute>
                    } 
                  />
                  
                  <Route 
                    path="/subscription/history" 
                    element={
                      <ProtectedRoute>
                        <SubscriptionPage initialTab="history" />
                      </ProtectedRoute>
                    } 
                  />
                  
                  {/* Protected routes */}
                  <Route 
                    path="/profile" 
                    element={
                      <ProtectedRoute>
                        <ProfilePage />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </main>
              
              <Footer />
            </div>
          </SubscriptionProvider>
        </AuthProvider>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;